import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[2],
    padding: theme.spacing(1),
    maxHeight:270,
    minWidth: "80%", // Increase the width to 80% of the container
  },
  title: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
  },
  propertyContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    "& > :last-child": {
      marginLeft: theme.spacing(2), // Add this line to add margin to the value
    },
  },
  label: {
    fontWeight: "bold",
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(2),
  },
  value: {
    color: theme.palette.text.primary,
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const CompanyInfo = ({ company }) => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardContent>
        <Typography variant="h6" className={classes.title}>
          Bill From
        </Typography>

      
        <div className={classes.propertyContainer}>
          <Typography className={classes.label}>Email</Typography>
          <Typography className={classes.value}>{company?.email}</Typography>
        </div>
        <div className={classes.propertyContainer}>
          <Typography className={classes.label}>Phone</Typography>
          <Typography className={classes.value}>{company?.phoneNo}</Typography>
        </div>
        <div className={classes.propertyContainer}>
          <Typography className={classes.label}>Address</Typography>
          <Typography className={classes.value}>{company?.address}</Typography>
        </div>
        <div className={classes.propertyContainer}>
          <Typography className={classes.label}>Organization</Typography>
          <Typography className={classes.value}>
            {company?.organization_name}
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
};

export default CompanyInfo;